import { MainContent } from "./main";
import "./main.css";
import { AsideBox } from "./AsideBox";
import { useContext } from "react";
import { toolsContext } from "../hooks/Context";

export function MainArea() {
  const toolContextData = useContext(toolsContext);

  return (
   <div className="container" style={{ paddingLeft: "10px", paddingRight: "10px" }}>
  <div className="row align-items-start"> {/* 👈 this aligns from top */}

    {/* MainContent */}
    <div
      className="col-md-10 d-flex flex-column"
      style={{ paddingLeft: "8px", paddingRight: "8px" }}
    >
      <MainContent />
    </div>

    {/* AsideBox */}
    <div
      className="col-md-2 d-none d-md-block"
      style={{
        paddingLeft: "8px",
        paddingRight: "8px",
      }}
    >
      <AsideBox />
    </div>

  </div>
</div>




  );
}


{/* <aside>
            {toolContextData.map((tool, i) => (
              <AsideBox key={i} title={tool.name} description={tool.description} />
            ))}
          </aside> */}